<template>
  <div class="w-full px-44 py-32 h-[90%] overflow-y-scroll scroll-hid">
    <div v-if="sectionNumber === 1">
      <about-first></about-first>
    </div>
    <div v-if="sectionNumber === 2">
      <about-second></about-second>
    </div>
    <div v-if="sectionNumber === 3">
      <about-tres></about-tres>
    </div>
    <div v-if="sectionNumber === 4">
      <about-four></about-four>
    </div>
  </div>
</template>


<script>
import AboutFirst from "@/components/AboutFirst.vue";
import AboutSecond from "./AboutSecond.vue";
import AboutTres from "./AboutTres.vue";
import AboutFour from "./AboutFour.vue";

export default {
  components: {
    AboutFirst,
    AboutSecond,
    AboutTres,
    AboutFour,
  },

  data() {
    return {
      isVisible: false,
      infoVisible: "people",
      studioVisible: "studio",
      practiceVisible: "scena",
      approachesVisible: "sustainability",
      sectionNumber: 1,
    };
  },
  methods: {
    infoShow() {
      this.isVisible = !this.isVisible;
    },
    changeInfo(newValue) {
      this.infoVisible = newValue;
      //console.log(this.infoVisible);
    },
    peopleShow(newValue) {
      this.studioVisible = newValue;
      //console.log(this.studioVisible);
    },
    practiceShow(newValue) {
      this.practiceVisible = newValue;
      //console.log(this.studioVisible);
    },
    approachesShow(newValue) {
      this.approachesVisible = newValue;
      //console.log(this.approachesVisible);
    },
    generateRandomNumber() {
      this.sectionNumber = Math.floor(Math.random() * 4) + 1;
    },
  },
  mounted() {
    this.generateRandomNumber();
  },
};
</script>

<style >
.scroll-hid {
  scrollbar-width: none;
}

.scroll-hid::-webkit-scrollbar {
  display: none;
}
</style>
